import * as React from "react";
import { useI18n } from "../domain/i18n";
import KVListComponent from "./KVListComponent";

const currentPageUrl = () => encodeURIComponent(window.location.href);

export interface SocialSharingToolbarProps {
  tabKey: string;
}

const SocialSharingToolbar = ({ tabKey }: SocialSharingToolbarProps) => {
  const I18n = useI18n();
  return (
    <div>
      <KVListComponent
        tabKey={tabKey}
        items={[
          {
            key: I18n.t("frontend.social-media.share.label"),
            value: (
              <span>
                <a
                  href={`http://twitter.com/intent/tweet/?url=${currentPageUrl()}&text=${I18n.t(
                    "frontend.social-media.share.text",
                  )}`}
                  className="button button--inline button--secondary"
                >
                  <i className="icon-twitter" />
                  <span>{" " + I18n.t("frontend.social-media.share.twitter")}</span>
                </a>
                <a
                  href={`http://www.facebook.com/sharer/sharer.php?u=${currentPageUrl()}&t=${I18n.t(
                    "frontend.social-media.share.text",
                  )}`}
                  className="button button--inline button--secondary mls"
                >
                  <i className="icon-facebook" />
                  <span>{" " + I18n.t("frontend.social-media.share.facebook")}</span>
                </a>
                <a
                  href={`http://plus.google.com/share?url=${currentPageUrl()}`}
                  className="button button--inline button--secondary mls"
                >
                  <i className="icon-googleplus" />
                  <span>{" " + I18n.t("frontend.social-media.share.googleplus")}</span>
                </a>
                <a
                  href={`mailto:?body=${I18n.t("frontend.social-media.share.text")}%0D%0A${currentPageUrl()}`}
                  className="button button--inline button--secondary mls"
                >
                  <i className="icon-mail" />
                  <span>{" " + I18n.t("frontend.social-media.share.email")}</span>
                </a>
              </span>
            ),
          },
        ]}
      />
    </div>
  );
};

export default SocialSharingToolbar;
